import { CartonLog } from "../models/carton.log";

import BaseService from "./_base.service";

const ROUTE_NAME = "cartons/log";

const CartonLogService = {
  ...BaseService<CartonLog>({ endpoint: ROUTE_NAME }),
};

export default CartonLogService;
